import React, { useEffect, useState } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { getProgramPoint } from "../../../services/auth";
import { getVoucherTemplateByMerchantCode } from "../../../services/services";
import { decrypt } from "../../../utils/encodingdecoding";
import { starHealthMerchantId } from "../../../utils";

const RedeemRewardsModal = (props) => {
    const { show, close, totalAvailableValue, handleRedeemApi, handleChange, error, successMsg, disable, inputRedeemPoints } = props;
    const [loader, setLoader] = useState(false);
    const [state, setState] = useState();
    const [options, setOptions] = useState([])
    const [templates, setTemplates] = useState([])
    const [redeemValue, setRedeemValue] = useState("");
    const [selectedTemplateCode, setSelectedTemplateCode] = useState("");

    useEffect(() => {
        const getMinimumPoint = async () => {
            try {
                setLoader(true);
                let token = await JSON.parse(localStorage.getItem("token_gen"));
                const response = await getProgramPoint(token?.access_token);
                const rewards = await getVoucherTemplateByMerchantCode(token.access_token);
                const allTemplates = rewards?.data || [];

                const activeTemplates = allTemplates.filter(
                    t => t.isActive !== false
                );
                const formattedTemplates = activeTemplates.map(template => ({
                    label: template.name,
                    value: Number(template.voucherValue),
                    code: template.code
                }));
                setOptions(formattedTemplates)
                setTemplates(activeTemplates);
                setState(response?.data[0]?.transactionPorcessingSettings.minimumRedeemValue);
                setLoader(false);
            } catch (err) { }
            finally {
                setLoader(false)
            }
        };
        getMinimumPoint();
    }, []);

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Modal show={show} onHide={close} centered>
                <Modal.Header>
                    <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>Redeem Points</Modal.Title>
                    <CloseButton onClick={close} variant="black" />
                </Modal.Header>
                <Modal.Body style={{ position: "relative", minHeight: "85px" }}>
                    {successMsg ? (
                        <span className="successMessage">{successMsg}</span>
                    ) : (
                        decrypt(localStorage.getItem("Id")) === starHealthMerchantId ? <>
                            <>
                                <label>Select Rewards</label>
                                <select
                                    className="form-control"
                                    value={redeemValue}
                                    onChange={(e) => {
                                        const selectedValue = Number(e.target.value);

                                        const selectedOption = options.find(
                                            (opt) => opt.value === selectedValue
                                        );

                                        if (selectedOption) {
                                            setSelectedTemplateCode(selectedOption.code);
                                        } else {
                                            setSelectedTemplateCode("");
                                        }
                                        setRedeemValue(e.target.value);
                                        handleChange(
                                            {
                                                target: {
                                                    name: "inputRedeemPoints",
                                                    value: e.target.value
                                                }
                                            },
                                            state
                                        );
                                    }}
                                >
                                    <option value="">Select Rewards</option>
                                    {options.map((opt, index) => (
                                        <option key={index} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>

                                <label className="mt-2">Redeem Points</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={redeemValue}
                                    readOnly
                                />

                                <span className="errorMessage">{error}</span>
                            </>
                        </> :
                            <>
                                <label>Redeem Points</label>
                                <input type="text" className="form-control" maxLength={totalAvailableValue.toString().length} name="inputRedeemPoints" defaultValue={totalAvailableValue} onChange={(e) => handleChange(e, state)} />
                                <span className="errorMessage">{error}</span>
                            </>
                    )}
                </Modal.Body>
                {!successMsg && (
                    <Modal.Footer>
                        <Button onClick={() => handleRedeemApi(templates, selectedTemplateCode)} disabled={decrypt(localStorage.getItem("Id")) === starHealthMerchantId ? selectedTemplateCode ? false : true : disable ? true : false}>
                            Redeem Points
                        </Button>
                    </Modal.Footer>
                )}
            </Modal >
        </>
    );
};

export default RedeemRewardsModal;
